import { Action, action, PayloadAction } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../common_types";

import { ContactActionTypes, ContactPayload } from "./types";

export const sendRequest = (
  params: ContactPayload & GatePayload
): PayloadAction<string, ContactPayload & GatePayload> => action(ContactActionTypes.SEND_REQUEST, params);

export const requestSuccess = (): Action => {
  message.success("Success");
  return action(ContactActionTypes.SEND_SUCCESS);
};

export const requestFailure = (errorMessage: string): Action => {
  message.error(errorMessage);
  return action(ContactActionTypes.SEND_FAILURE);
};
